import * as React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import StrongAuth from 'components/StrongAuth/StrongAuth';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import * as TwoFactorAuthAnalytics from './TwoFactorAuthAnalytics';
import { FlowType } from '@rome/request/user/generateotp/v8/FlowType';
var OtpRequestType;
(function (OtpRequestType) {
    OtpRequestType["RESEND"] = "RESEND";
})(OtpRequestType || (OtpRequestType = {}));
var ToastLevel;
(function (ToastLevel) {
    ToastLevel["SUCCESS"] = "SUCCESS";
    ToastLevel["ERROR"] = "ERROR";
})(ToastLevel || (ToastLevel = {}));
export const TWO_FACTOR_AUTHENTICATION_MESSAGE = {
    TWO_FACTOR_AUTHENTICATION: 'TWO_FACTOR_AUTHENTICATION',
    SUCCESS: 'SUCCESS'
};
class TwoFactorAuth extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            requestId: '',
            userId: '',
            hasOtpFailed: false,
            isResendOtpEnabled: true,
            isOtpTimerVisible: false,
            isStrongAuthVisible: false,
            generateOtpState: AsyncStatus.INIT,
            verifyOtpState: AsyncStatus.INIT
        };
        this.errorToast = (message, context) => {
            const toastErrorMessage = {
                message,
                ttl: 3000,
                level: ToastLevel.ERROR
            };
            message && context.toast.show(toastErrorMessage);
        };
        this.successToast = (message, context) => {
            const toastSuccessMessage = {
                message,
                ttl: 3000,
                level: ToastLevel.SUCCESS
            };
            message && context.toast.show(toastSuccessMessage);
        };
        this.onGenerateOtp = (requestType = '') => {
            const payload = {
                flowType: FlowType.TWO_FACTOR_AUTHENTICATION
            };
            if (requestType !== OtpRequestType.RESEND) {
                TwoFactorAuthAnalytics.sendOpen2FA({
                    siteSection: this.props.siteSectionType
                });
            }
            this.setState({ generateOtpState: AsyncStatus.LOADING }, () => {
                this.props.generateLoginIdentityVerifyOtp(payload).then(otpInfo => {
                    const message = get(otpInfo, 'data.toastMessage.text', '');
                    this.successToast(message, this.context);
                    // setting requestId and userId in state
                    const otpIdentifierInfo = get(otpInfo, 'data.otpIdentifierInfo.0', '');
                    this.setState({
                        requestId: get(otpIdentifierInfo, 'requestId', ''),
                        userId: get(otpIdentifierInfo, 'userId', ''),
                        isOtpTimerVisible: requestType === OtpRequestType.RESEND ? true : false,
                        isResendOtpEnabled: requestType === OtpRequestType.RESEND ? false : true,
                        generateOtpState: AsyncStatus.SUCCESS
                    });
                }, errorResponse => {
                    const message = get(errorResponse, 'error.message', '');
                    const { isOtpTimerVisible } = this.state;
                    this.errorToast(message, this.context);
                    this.setState({
                        isResendOtpEnabled: !isOtpTimerVisible ? true : false,
                        generateOtpState: AsyncStatus.ERROR
                    });
                });
            });
        };
        this.onSubmitOtp = (otp = '') => {
            const { requestId, userId } = this.state;
            const finalOtp = otp.replace(/ /g, '');
            const payload = {
                otp: finalOtp,
                requestId,
                userId
            };
            const { onSuccessFn } = this.props;
            TwoFactorAuthAnalytics.sendOtpEntered({
                siteSection: this.props.siteSectionType
            });
            this.setState({ verifyOtpState: AsyncStatus.LOADING }, () => {
                this.props.validate2FaAction(payload).then(response => {
                    this.setState({ verifyOtpState: AsyncStatus.SUCCESS, hasOtpFailed: false, isResendOtpEnabled: true }, () => {
                        if (this.props.canShowSuccessToast) {
                            const message = get(response, 'data.message', '');
                            this.successToast(message, this.context);
                        }
                        TwoFactorAuthAnalytics.sendCorrectOtpEntered({
                            siteSection: this.props.siteSectionType
                        });
                        if (typeof onSuccessFn === 'function') {
                            onSuccessFn();
                        }
                    });
                }, errorResponse => {
                    const { isOtpTimerVisible } = this.state;
                    this.setState({
                        verifyOtpState: AsyncStatus.ERROR,
                        hasOtpFailed: true,
                        isResendOtpEnabled: !isOtpTimerVisible ? true : false
                    }, () => {
                        const message = get(errorResponse, 'message', '');
                        this.errorToast(message, this.context);
                        TwoFactorAuthAnalytics.sendIncorrectOtpEntered({
                            siteSection: this.props.siteSectionType
                        });
                    });
                });
            });
        };
        this.onResendOtp = () => {
            TwoFactorAuthAnalytics.sendOtpResend({
                siteSection: this.props.siteSectionType
            });
            this.onGenerateOtp(OtpRequestType.RESEND);
        };
        this.disableOtpTimer = () => {
            this.setState({ isOtpTimerVisible: false, isResendOtpEnabled: true });
        };
    }
    render() {
        const { hasOtpFailed, isResendOtpEnabled, isOtpTimerVisible, userId, generateOtpState, verifyOtpState } = this.state;
        const { isVerifyInfoVisible, numberOfInputsOtp = 6, titleInfoText } = this.props;
        return (<StrongAuth generateOtp={this.onGenerateOtp} onSubmitOtp={this.onSubmitOtp} onResendOtp={this.onResendOtp} hasOtpFailed={hasOtpFailed} isResendOtpEnabled={isResendOtpEnabled} isOtpTimerVisible={isOtpTimerVisible} disableOtpTimer={this.disableOtpTimer} userId={userId} generateOtpState={generateOtpState} numberOfInputs={numberOfInputsOtp} isVerifyInfoVisible={isVerifyInfoVisible} verifyOtpState={verifyOtpState} titleInfoText={titleInfoText}/>);
    }
}
TwoFactorAuth.defaultProps = {
    isVerifyInfoVisible: true,
    numberOfInputsOtp: 6,
    canShowSuccessToast: true
};
TwoFactorAuth.contextTypes = {
    modal: PropTypes.object.isRequired,
    toast: PropTypes.object.isRequired
};
export default TwoFactorAuth;
